export function createFrame(src) {
  let frame = document.createElement('IFRAME');
  frame.style.display = 'none';
  frame.src = src;
  document.body.appendChild(frame);
  return frame;
};

export function getWindow() {
  let theWindow = window;
  let testCanGetTop = false;

  // 如果是在iframe内
  if (window.parent !== window) {
    // 通过try尝试是否可以取到top的属性，否则就是取不到 hack...
    try {
      testCanGetTop = window.top.document;
      testCanGetTop = true;
    } catch (e) {
      testCanGetTop = false;
    }
    if (testCanGetTop) {
      theWindow = window.top;
    }
  }
  return theWindow;
};



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/util/dom.js